import gameiomModel from "gameiom/model/gameiom-model";
import Layers from "slotworks/graphics/layers/layers";
import ControlList from "slotworks/smart-ui/control-list";
import CancelAutoControl from "slotworks/smart-ui/controls/spin/cancel-auto-control";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class AGSCancelAutoControl extends CancelAutoControl {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
        ControlList.removeControl(ControlList.AUTO_STOP);
    }

    public setEnabled(enabled: boolean) {
        if (gameiomModel.disableSpinSkip && this.gameIsAutoPlay()) {
            enabled = true;
        }
        super.setEnabled(enabled);
    }

    private gameIsAutoPlay() {
        return (SmartUIFlags.bitmask & SmartUIFlag.AUTO_SPIN) === SmartUIFlag.AUTO_SPIN;
    }
}
